var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSnacksuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5494",
    "data-name": "Group 5494",
    transform: "translate(-636 -1759)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8809",
    "data-name": "Rectangle 8809",
    width: 20,
    height: 20,
    rx: 10,
    transform: "translate(636 1759)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18006",
    "data-name": "Path 18006",
    d: "M1187.471,717.3l4.1,4.042,7.032-7.023",
    transform: "translate(-546.846 1050.441)",
    fill: "none",
    stroke: "#51a300",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnacksuccess);
export default __webpack_public_path__ + "static/media/Snacksuccess.c9fd2bde3bfa1ac48f7a42000a0c1e89.svg";
export { ForwardRef as ReactComponent };